// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invResourceId } from './InvResource';
import { invResourceCategoryId } from './InvResourceCategory';
import { fermLineDriveEnum } from './FermLineDriveEnum';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationLineTypeId = (z.number());
export const fermentationLineType = z.object({
    id: fermentationLineTypeId,
    code: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    feed_resource_id: invResourceId.nullable(),
    feed_resource_category_id: invResourceCategoryId.nullable(),
    has_concentration: z.boolean(),
    default_drive: fermLineDriveEnum,
    display_order: z.number(),
    color: z.string().nullable(),
    is_system: z.boolean(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    swap_at_g: z.string().nullable(),
});
export const fermentationLineTypeInitializer = z.object({
    id: fermentationLineTypeId.optional(),
    code: z.string(),
    name: z.string(),
    description: z.string().optional().nullable(),
    feed_resource_id: invResourceId.optional().nullable(),
    feed_resource_category_id: invResourceCategoryId.optional().nullable(),
    has_concentration: z.boolean().optional(),
    default_drive: fermLineDriveEnum.optional(),
    display_order: z.number().optional(),
    color: z.string().optional().nullable(),
    is_system: z.boolean().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    swap_at_g: z.string().optional().nullable(),
});
export const fermentationLineTypeMutator = z.object({
    id: fermentationLineTypeId.optional(),
    code: z.string().optional(),
    name: z.string().optional(),
    description: z.string().optional().nullable(),
    feed_resource_id: invResourceId.optional().nullable(),
    feed_resource_category_id: invResourceCategoryId.optional().nullable(),
    has_concentration: z.boolean().optional(),
    default_drive: fermLineDriveEnum.optional(),
    display_order: z.number().optional(),
    color: z.string().optional().nullable(),
    is_system: z.boolean().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    swap_at_g: z.string().optional().nullable(),
});
//# sourceMappingURL=FermentationLineType.js.map